import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AccountMenu, { SignupLink } from "@/components/AccountMenu";

export function BackLink({ testId = "page-back-link", label = "Back", className = "" }) {
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate("/");
  };
  return (
    <button
      onClick={goBack}
      data-testid={testId}
      className={`group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#374151] hover:text-[#FF4E00] transition-colors duration-300 ${className}`}
    >
      <ArrowLeft className="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-1" />
      {label}
    </button>
  );
}

export default function PageHeader() {
  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur-xl bg-[#FBF9F5]/80 border-b border-[#0D1117]/10">
      <nav className="px-6 sm:px-12 lg:px-20 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" data-testid="page-brand-logo" className="group flex items-center">
          <img src="/logo-horizontal.png" alt="Fitygrity" className="h-8 sm:h-9 w-auto object-contain rounded-md transition-opacity duration-300 group-hover:opacity-80" />
        </Link>
        <div className="flex items-center gap-4 sm:gap-8">
          <Link
            to="/calendar"
            className="hidden sm:inline font-mono text-xs uppercase tracking-[0.2em] text-[#374151] hover:text-[#FF4E00] transition-colors duration-300"
          >
            Race Calendar
          </Link>
          <SignupLink
            testId="header-link-signup"
            className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.2em] whitespace-nowrap text-[#FF4E00] hover:text-[#E04000] transition-colors duration-300"
          />
          <AccountMenu />
          <BackLink />
        </div>
      </nav>
    </header>
  );
}
